// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#005f73","colorSecondary":"#ed1002","colorInfo":"#005f73","colorError":"#ed1002","colorSuccess":"#3d9149","font":"\"Manrope\",sans-serif"};